import DataTable from "@/components/Common/DataTable";
import { useMemo, useState } from "react";
import createColumns from "./columns";
import ApprovalAlertDialog from "./ApprovalAlertDialog";
import { ScenarioDecision } from "@/consts/Scenario";
import {
  useReadScenarioApprovals,
  useUpdateScenarioApprovals,
} from "@/libs/react-query/hooks/useScenarioApprovalsQuery";
import { showToast } from "@/utils/toastUtils";
import { useNavigate } from "react-router-dom";

export default function ApprovalTable() {
  const [openAlert, setOpenAlert] = useState(false);
  const [dialogType, setDialogType] = useState<
    ScenarioDecision.APPROVED | ScenarioDecision.REJECTED
  >();
  const [approvalId, setApprovalId] = useState<string>("");

  const navigate = useNavigate();

  const { mutate: submitApproval } = useUpdateScenarioApprovals();
  const { data } = useReadScenarioApprovals({
    pagination: {
      page: 0,
      limit: Number.MAX_SAFE_INTEGER,
    },
  });
  const { scenario_approvals: approvals = [] } = data || {};

  const handleSubmit = (reason: string) => {
    if (!approvalId || !dialogType) return;

    submitApproval(
      {
        approval_id: approvalId,
        data: { decision: dialogType, reason },
      },
      {
        onSuccess: () => {
          showToast({
            message: "승인 시나리오가 성공적으로 처리되었습니다.",
          });
        },
      }
    );

    setOpenAlert(false);
    setApprovalId("");
  };

  const handleProjectTitleClick = (projectGroupId: string) => {
    navigate(`/management/projects/${projectGroupId}`);
  };

  const handleTableClick = (
    approvalId: string,
    myApproval?: any,
    receiveType?: string
  ) => {
    navigate(`/approvals/${approvalId}`, {
      state: {
        my_approval: myApproval,
        receive_type: receiveType,
      },
    });
  };

  const columns = createColumns({
    setApprovalId,
    setDialogType,
    setOpenAlert,
    onRowClick: (projectGroupId: string) =>
      handleProjectTitleClick(projectGroupId),
    onTableClick: handleTableClick,
  });

  const selectedApproval = useMemo(
    () => approvals.find((a) => a.approval_id === approvalId) ?? null,
    [approvalId, approvals]
  );

  const dataWithRowClick = useMemo(() => {
    return approvals.map((item) => ({
      ...item,
      onRowClick: () => navigate(`/approvals/${item.approval_id}`),
    }));
  }, [approvals]);

  return (
    <div className="p-5">
      <DataTable
        columns={columns}
        data={dataWithRowClick}
        isPagination={true}
        tableCellClassName="py-2 px-3"
      />

      <ApprovalAlertDialog
        open={openAlert}
        onClose={() => {
          setApprovalId("");
          setOpenAlert(false);
        }}
        onSubmit={handleSubmit}
        type={
          dialogType as ScenarioDecision.APPROVED | ScenarioDecision.REJECTED
        }
      />
    </div>
  );
}
